import Section from "@ludens-reklame/rubics-theme/dist/components/Section";

export default Section;
